import { EBOOKS_ACTIONS } from 'app/store/actions/media/ebooks.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { EBooksInitialState } from 'app/types/ebooks-reducers.types'

const initialState: EBooksInitialState = {
  data: [],
  loading: true,
  error: false,
}

const Library = baseRequestReducer(initialState, EBOOKS_ACTIONS)

export default Library
